// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".advanced-settings-panels .briq-form-element {\n  margin-bottom: 24px;\n}\n.search-input {\n  width: 80%;\n  margin-right: 20px;\n}\n.expand-panels-switch {\n  width: 20%;\n}\n.briq-expansion-panel {\n  transition: margin 0.3s ease-out;\n}\n.briq-expansion-panel.expanded:not(:first-of-type),\n.briq-expansion-panel.expanded+.briq-expansion-panel {\n  margin-top: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
